import { render, staticRenderFns } from "./setFail.vue?vue&type=template&id=71f652a2&scoped=true&"
import script from "./setFail.vue?vue&type=script&lang=js&"
export * from "./setFail.vue?vue&type=script&lang=js&"
import style0 from "./setFail.vue?vue&type=style&index=0&id=71f652a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f652a2",
  null
  
)

export default component.exports